import React, { useState, useEffect, useRef } from 'react';
import './MeetOurTeam.css';

const teamMembers = [
  {
    name: "Akkiraju Hari Kishore",
    role: "Program Chief Advisor",
    image: "/meetourteam/akkiraju.png",
    linkedin: "https://www.linkedin.com/in/akkirajukishore/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    portfolio: "akkirajuharikrishna@gmail.com",
    achievements: "IT leader with strong experience in AI/ML and enterprise transformation. Passionate about innovation in automation, RAG, and autonomous agents."
  },
  {
    name: "Raja Sekhar Thota",
    role: "Program Instructor",
    image: "/meetourteam/rajasekhar.png",
    linkedin: "https://www.linkedin.com/in/rajaathota72/",
    portfolio: "https://bento.me/rajathota", // ✅ Updated to proper portfolio link
    achievements: "As CTO and Co-Founder of AuditOne GmbH, I drive innovation in blockchain security through auditor platforms, trust APIs, and automated Web3 audit tools, leveraging my expertise in Python, AI, and ML. I also co-founded Robokalam, training 500+ learners in machine learning, and led inclusive tech programs with The Code To Change, earning national recognition for social innovation."
  },
  {
    name: "Shamini",
    role: "Program Instructor",
    image: "/meetourteam/shamini.png",
    linkedin: "https://www.linkedin.com/in/shamini-koravuna-1980927a/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    portfolio: "shamini@gmail.com",
    achievements: "PhD researcher at Bielefeld University specializing in AI and TinyML. Published multiple papers on efficient neural networks for edge devices."
  },
  {
    name: "Mohammed Sajeed",
    role: "Program Instructor",
    image: "/meetourteam/sajeed.png",
    linkedin: "https://www.linkedin.com/in/msajeed25/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    portfolio: "https://sj.robokalam.com/",
    achievements: "Entrepreneur with experience across edtech, healthcare, and e-commerce sectors. Known for driving digital innovation and mentoring startups."
  }
];

const MeetOurTeam = () => {
  const [selectedMember, setSelectedMember] = useState(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add("fade-up");
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
  }, []);

  useEffect(() => {
    // Prevent scroll when modal is open
    document.body.style.overflow = selectedMember ? 'hidden' : 'auto';
  }, [selectedMember]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setSelectedMember(null);
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  const handleAboutClick = (member) => {
    setSelectedMember(member);
  };

  const closeModal = () => {
    setSelectedMember(null);
  };

  return (
    <>
      <div ref={sectionRef} className="team-section animate-section">
        <div className="d-flex flex-column align-items-center">
          <h2 className="team-title">Meet Our Team</h2>
        </div>
        <div className="team-container">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-member">
              <img src={member.image} alt={member.name} className="team-image" />
              <h3 className="team-name">{member.name}</h3>
              <p className="team-role">{member.role}</p>

              <button className="achievement-btn" onClick={() => handleAboutClick(member)}>About</button>

              <div className="social-links">
                <a href={member.linkedin} target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-linkedin"></i>
                </a>
                {member.portfolio.includes("http") ? (
                  <a href={member.portfolio} target="_blank" rel="noopener noreferrer">
                    <i className="fas fa-briefcase"></i>
                  </a>
                ) : (
                  <a href={`mailto:${member.portfolio}`}>
                    <i className="fas fa-briefcase"></i>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ✅ Modal placed outside main container */}
      {selectedMember && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex justify-content-center">
              <h3>{selectedMember.name}</h3>
            </div>
            <p><strong>Role:</strong> {selectedMember.role}</p>
            <p><strong>Achievements:</strong> {selectedMember.achievements}</p>
            <div className="d-flex justify-content-center">
              <button className="close-modal" onClick={closeModal}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MeetOurTeam;
